import { ReactNode, Ref } from 'react'

import { BodyVariant, SizeOptions } from '../../types/types'
import { AstraParagraph } from '../Typography/AstraParagraph/AstraParagraph'
import { astraTwMerge } from '../Utilities/astraTwMerge'

type Props = {
    /**
     * The size of the placeholder element - affects font size and padding
     */
    size?: SizeOptions
    /**
     * The text to display
     */
    text: ReactNode
    /**
     * Ref to the div element
     */
    ref?: Ref<HTMLDivElement>
    /**
     * data-testid for testing purposes
     */
    'data-test'?: string
}

const fontStyles: Record<SizeOptions, BodyVariant> = {
    small: 'body-small',
    medium: 'body',
    large: 'body-large',
}

const sizeStyles: Record<SizeOptions, string> = {
    small: 'rounded px-3 py-1.5',
    medium: 'rounded-md px-3.5 py-2',
    large: 'rounded-lg px-4 py-2',
}

export const AstraEmpty = ({ ref, size = 'medium', text, ...props }: Props) => (
    <div ref={ref} role="status" aria-live="polite" {...props} className={astraTwMerge('border border-transparent bg-surface-strong', sizeStyles[size])}>
        {typeof text === 'string' ? (
            <AstraParagraph variant={fontStyles[size]} className="text-default">
                {text}
            </AstraParagraph>
        ) : (
            text
        )}
    </div>
)
